/**
 * Rich Text Editor classes defined here.
 */
/**
 * @hidden

 */
export var CLS_RTE = 'e-richtexteditor';
/**
 * @hidden

 */
export var CLS_RTL = 'e-rtl';
/**
 * @hidden

 */
export var CLS_CONTENT = 'e-content';
/**
 * @hidden

 */
export var CLS_DISABLED = 'e-disabled';
/**
 * @hidden

 */
export var CLS_SCRIPT_SHEET = 'rte-iframe-script-sheet';
/**
 * @hidden

 */
export var CLS_STYLE_SHEET = 'rte-iframe-style-sheet';
/**
 * @hidden

 */
export var CLS_RTE_CONTAINER = 'e-rte-container';
/**
 * @hidden

 */
export var CLS_TOOLBAR = 'e-rte-toolbar';
/**
 * @hidden

 */
export var CLS_TB_FIXED = 'e-rte-tb-fixed';
/**
 * @hidden

 */
export var CLS_TB_FLOAT = 'e-rte-tb-float';
/**
 * @hidden

 */
export var CLS_INLINE = 'e-rte-inline';
/**
 * @hidden

 */
export var CLS_TB_INLINE = 'e-rte-tb-inline';
/**
 * @hidden

 */
export var CLS_RTE_EXPAND_TB = 'e-rte-tb-expand';
/**
 * @hidden

 */
export var CLS_FULL_SCREEN = 'e-rte-full-screen';
/**
 * @hidden

 */
export var CLS_QUICK_TB = 'e-rte-quick-toolbar';
/**
 * @hidden

 */
export var CLS_TEXT_QUICK_TB = 'e-rte-text-quicktoolbar';
/**
 * @hidden

 */
export var CLS_POP = 'e-rte-pop';
/**
 * @hidden

 */
export var CLS_TB_STATIC = 'e-tb-static';
/**
 * @hidden

 */
export var CLS_QUICK_POP = 'e-rte-quick-popup';
/**
 * @hidden

 */
export var CLS_QUICK_DROPDOWN = 'e-quick-dropdown';
/**
 * @hidden

 */
export var CLS_IMAGE_POP = 'e-rte-image-popup';
/**
 * @hidden

 */
export var CLS_TEXT_POP = 'e-rte-text-popup';
/**
 * @hidden

 */
export var CLS_INLINE_POP = 'e-rte-inline-popup';
/**
 * @hidden

 */
export var CLS_INLINE_DROPDOWN = 'e-rte-inline-dropdown';
/**
 * @hidden

 */
export var CLS_DROPDOWN_POPUP = 'e-rte-dropdown-popup';
/**
 * @hidden

 */
export var CLS_DROPDOWN_ICONS = 'e-rte-dropdown-icons';
/**
 * @hidden

 */
export var CLS_DROPDOWN_ITEMS = 'e-rte-dropdown-items';
/**
 * @hidden

 */
export var CLS_DROPDOWN_BTN = 'e-rte-dropdown-btn';
/**
 * @hidden

 */
export var CLS_RTE_CONTENT = 'e-rte-content';
/**
 * @hidden

 */
export var CLS_TB_ITEM = 'e-toolbar-item';
/**
 * @hidden

 */
export var CLS_TB_EXTENDED = 'e-toolbar-extended';
/**
 * @hidden

 */
export var CLS_TB_WRAP = 'e-toolbar-wrapper';
/**
 * @hidden

 */
export var CLS_POPUP = 'e-popup';
/**
 * @hidden

 */
export var CLS_SEPARATOR = 'e-separator';
/**
 * @hidden

 */
export var CLS_MINIMIZE = 'e-minimize';
/**
 * @hidden

 */
export var CLS_MAXIMIZE = 'e-maximize';
/**
 * @hidden

 */
export var CLS_BACK = 'e-back';
/**
 * @hidden

 */
export var CLS_SHOW = 'e-show';
/**
 * @hidden

 */
export var CLS_HIDE = 'e-hide';
/**
 * @hidden

 */
export var CLS_VISIBLE = 'e-visible';
/**
 * @hidden

 */
export var CLS_FOCUS = 'e-focused';
/**
 * @hidden

 */
export var CLS_RM_WHITE_SPACE = 'e-remove-white-space';
/**
 * @hidden

 */
export var CLS_IMGRIGHT = 'e-imgright';
/**
 * @hidden

 */
export var CLS_IMGLEFT = 'e-imgleft';
/**
 * @hidden

 */
export var CLS_IMGCENTER = 'e-imgcenter';
/**
 * @hidden

 */
export var CLS_IMGBREAK = 'e-imgbreak';
/**
 * @hidden

 */
export var CLS_AUDIOBREAK = 'e-audio-break';
/**
 * @hidden

 */
export var CLS_CLICKELEM = 'e-clickelem';
/**
 * @hidden

 */
export var CLS_VID_CLICK_ELEM = 'e-video-clickelem';
/**
 * @hidden

 */
export var CLS_AUDIOWRAP = 'e-audio-wrap';
/**
 * @hidden

 */
export var CLS_VIDEOWRAP = 'e-video-wrap';
/**
 * @hidden

 */
export var CLS_VIDEOBREAK = 'e-video-break';
/**
 * @hidden

 */
export var CLS_CAPTION = 'e-img-caption';
/**
 * @hidden

 */
export var CLS_RTE_CAPTION = 'e-rte-img-caption';
/**
 * @hidden

 */
export var CLS_CAPINLINE = 'e-caption-inline';
/**
 * @hidden

 */
export var CLS_IMGINLINE = 'e-imginline';
/**
 * @hidden

 */
export var CLS_AUDIOINLINE = 'e-audio-inline';
/**
 * @hidden

 */
export var CLS_VIDEOINLINE = 'e-video-inline';
/**
 * @hidden

 */
export var CLS_COUNT = 'e-rte-character-count';
/**
 * @hidden

 */
export var CLS_WARNING = 'e-warning';
/**
 * @hidden

 */
export var CLS_ERROR = 'e-error';
/**
 * @hidden

 */
export var CLS_ICONS = 'e-icons';
/**
 * @hidden

 */
export var CLS_ACTIVE = 'e-active';
/**
 * @hidden

 */
export var CLS_EXPAND_OPEN = 'e-expand-open';
/**
 * @hidden

 */
export var CLS_RTE_ELEMENTS = 'e-rte-elements';
/**
 * @hidden

 */
export var CLS_TB_BTN = 'e-tbar-btn';
/**
 * @hidden

 */
export var CLS_HR_SEPARATOR = 'e-rte-horizontal-separator';
/**
 * @hidden

 */
export var CLS_TB_IOS_FIX = 'e-tbar-ios-fixed';
/**
 * @hidden

 */
export var CLS_LIST_PRIMARY_CONTENT = 'e-rte-list-primary-content';
/**
 * @hidden

 */
export var CLS_NUMBERFORMATLIST_TB_BTN = 'e-rte-numberformatlist-dropdown';
/**
 * @hidden

 */
export var CLS_BULLETFORMATLIST_TB_BTN = 'e-rte-bulletformatlist-dropdown';
/**
 * @hidden

 */
export var CLS_FORMATS_TB_BTN = 'e-formats-tbar-btn';
/**
 * @hidden

 */
export var CLS_FONT_NAME_TB_BTN = 'e-font-name-tbar-btn';
/**
 * @hidden

 */
export var CLS_FONT_SIZE_TB_BTN = 'e-font-size-tbar-btn';
/**
 * @hidden

 */
export var CLS_ALIGN_TB_BTN = 'e-alignment-tbar-btn';
/**
 * @hidden

 */
export var CLS_FONT_COLOR_TARGET = 'e-rte-fontcolor-element';
/**
 * @hidden

 */
export var CLS_BACKGROUND_COLOR_TARGET = 'e-rte-backgroundcolor-element';
/**
 * @hidden

 */
export var CLS_COLOR_CONTENT = 'e-rte-color-content';
/**
 * @hidden

 */
export var CLS_FONT_COLOR_DROPDOWN = 'e-rte-fontcolor-dropdown';
/**
 * @hidden

 */
export var CLS_BACKGROUND_COLOR_DROPDOWN = 'e-rte-backgroundcolor-dropdown';
/**
 * @hidden

 */
export var CLS_COLOR_PALETTE = 'e-rte-square-palette';
/**
 * @hidden

 */
export var CLS_FONT_COLOR_PICKER = 'e-rte-fontcolor-colorpicker';
/**
 * @hidden

 */
export var CLS_BACKGROUND_COLOR_PICKER = 'e-rte-backgroundcolor-colorpicker';
/**
 * @hidden

 */
export var CLS_RTE_READONLY = 'e-rte-readonly';
/**
 * @hidden

 */
export var CLS_TABLE_SEL = 'e-cell-select';
/**
 * @hidden

 */
export var CLS_TABLE_SEL_END = 'e-cell-select-end';
/**
 * @hidden

 */
export var CLS_TABLE_MULTI_CELL = 'e-multi-cells-select';
/**
 * @hidden

 */
export var CLS_TB_DASH_BOR = 'e-dashed-border';
/**
 * @hidden

 */
export var CLS_TB_ALT_BOR = 'e-alternate-border';
/**
 * @hidden

 */
export var CLS_TB_COL_RES = 'e-column-resize';
/**
 * @hidden

 */
export var CLS_TB_ROW_RES = 'e-row-resize';
/**
 * @hidden

 */
export var CLS_TB_BOX_RES = 'e-table-box';
/**
 * @hidden

 */
export var CLS_RTE_HIDDEN = 'e-rte-hidden';
/**
 * @hidden

 */
export var CLS_RTE_PASTE_KEEP_FORMAT = 'e-rte-keepformat';
/**
 * @hidden

 */
export var CLS_RTE_PASTE_REMOVE_FORMAT = 'e-rte-removeformat';
/**
 * @hidden

 */
export var CLS_RTE_PASTE_PLAIN_FORMAT = 'e-rte-plainformat';
/**
 * @hidden

 */
export var CLS_RTE_PASTE_OK = 'e-rte-pasteok';
/**
 * @hidden

 */
export var CLS_RTE_PASTE_CANCEL = 'e-rte-pastecancel';
/**
 * @hidden

 */
export var CLS_RTE_DIALOG_MIN_HEIGHT = 'e-rte-dialog-minheight';
/**
 * @hidden

 */
export var CLS_RTE_RES_HANDLE = 'e-resize-handle';
/**
 * @hidden

 */
export var CLS_RTE_RES_EAST = 'e-south-east';
/**
 * @hidden

 */
export var CLS_RTE_IMAGE = 'e-rte-image';
/**
 * @hidden

 */
export var CLS_RESIZE = 'e-resize';
/**
 * @hidden

 */
export var CLS_IMG_FOCUS = 'e-img-focus';
/**
 * @hidden

 */
export var CLS_AUD_FOCUS = 'e-audio-focus';
/**
 * @hidden

 */
export var CLS_VID_FOCUS = 'e-video-focus';
/**
 * @hidden

 */
export var CLS_RTE_DRAG_IMAGE = 'e-rte-drag-image';
/**
 * @hidden

 */
export var CLS_RTE_UPLOAD_POPUP = 'e-rte-upload-popup';
/**
 * @hidden

 */
export var CLS_POPUP_OPEN = 'e-popup-open';
/**
 * @hidden

 */
export var CLS_IMG_RESIZE = 'e-img-resize';
/**
 * @hidden

 */
export var CLS_DROPAREA = 'e-droparea';
/**
 * @hidden

 */
export var CLS_IMG_INNER = 'e-img-inner';
/**
 * @hidden

 */
export var CLS_UPLOAD_FILES = 'e-upload-files';
/**
 * @hidden

 */
export var CLS_RTE_DIALOG_UPLOAD = 'e-rte-dialog-upload';
/**
 * @hidden

 */
export var CLS_RTE_RES_CNT = 'e-rte-resize';
/**
 * @hidden

 */
export var CLS_CUSTOM_TILE = 'e-custom-tile';
/**
 * @hidden

 */
export var CLS_NOCOLOR_ITEM = 'e-nocolor-item';
/**
 * @hidden

 */
export var CLS_TABLE = 'e-rte-table';
/**
 * @hidden

 */
export var CLS_TABLE_BORDER = 'e-rte-table-border';
/**
 * @hidden

 */
export var CLS_RTE_TABLE_RESIZE = 'e-rte-table-resize';
/**
 * @hidden

 */
export var CLS_RTE_FIXED_TB_EXPAND = 'e-rte-fixed-tb-expand';
/**
 * @hidden

 */
export var CLS_RTE_TB_ENABLED = 'e-rte-toolbar-enabled';
/**
 * @hidden

 */
export var CLS_RTE_RES_WEST = 'e-south-west';
/**
 * @hidden

 */
export var CLS_RTE_SOURCE_CODE_TXTAREA = 'e-rte-srctextarea';
/**
 * @hidden

 */
export var ALLOWED_ACTIONKEYS = ['Enter', 'ArrowRight', 'ArrowLeft'];
